// Sources:
// https://docs.metamask.io/wallet/reference/json-rpc-methods/wallet_switchethereumchain/
// https://docs.metamask.io/guide/rpc-api.html#usage-with-wallet-switchethereumchain

const isRecord = (value: unknown) =>
  typeof value === 'object' && value !== null;

/** @not-instrumented */
// eslint-disable-next-line custom-rules/require-single-object-param
export const isUnrecognizedChainError = (error: object) => {
  const isCode4902 = 'code' in error && error.code === 4902;

  const hasUnrecognizedChainMessage =
    'message' in error &&
    typeof error.message === 'string' &&
    error.message.toLowerCase().includes('unrecognized chain');

  const isOriginalErrorCode4902 =
    'data' in error &&
    isRecord(error.data) &&
    'originalError' in error.data &&
    isRecord(error.data.originalError) &&
    'code' in error.data.originalError &&
    error.data.originalError.code === 4902;

  return isCode4902 || hasUnrecognizedChainMessage || isOriginalErrorCode4902;
};
